import { StyleSheet, View } from 'react-native';
import { HEADER } from './header.constants';
import { THeaderProps } from './Header.types';
import { MainLogoPressable } from '../../main-logo-pressable/MainLogoPressable';
import { neutrals } from 'src/theme/colors';
import { TestIDs } from 'src/constants/testIDs.constants';
import { desktopTestID } from 'src/helpers/testIDs.helper';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';

export const HeaderDesktop = ({ leftElement, centerElement, rightElement }: THeaderProps) => {
  return (
    <View style={styles.container} testID={desktopTestID(TestIDs.HEADER)}>
      <View style={styles.leftElement}>{leftElement}</View>
      <View>
        {centerElement ? (
          centerElement
        ) : (
          <MainLogoPressable
            testID={TestIDs.PHOTOSI_LOGO}
            focusId={TestIDs.PHOTOSI_LOGO}
            focusOrder={0}
            focusGroup={FocusGroups.HEADER}
          />
        )}
      </View>
      <View style={styles.rightElement}>{rightElement}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: neutrals.white,
    width: '100%',
    height: HEADER.height.desktop,
    shadowColor: neutrals.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4, // Android only
    zIndex: 1,
  },
  rightElement: {
    flex: 1,
    alignItems: 'flex-end',
  },
  leftElement: {
    flex: 1,
    alignItems: 'flex-start',
  },
});
